import React from "react";
import { Check, X, Zap, ShieldCheck, Building2, Globe2, Boxes, Clock } from "lucide-react";
import { useT } from "@/lib/i18n";

const COMPARE = [
  ["Same-day operational quotes", true, false],
  ["In-house EU customs experts", true, false],
  ["DDP + Importer of Record under one roof", true, false],
  ["Amazon FBA prep + delivery", true, false],
  ["Exhibition / ATA Carnet handling", true, false],
  ["White-glove Aerospace & Automotive", true, false],
  ["Live shipment + compliance scoring", true, false],
];

export default function WhyZopran() {
  const { t } = useT();
  const PILLARS = [
    { icon: Zap, t: t("why.pillar1.t"), d: t("why.pillar1.d") },
    { icon: ShieldCheck, t: t("why.pillar2.t"), d: t("why.pillar2.d") },
    { icon: Building2, t: t("why.pillar3.t"), d: t("why.pillar3.d") },
    { icon: Globe2, t: t("why.pillar4.t"), d: t("why.pillar4.d") },
    { icon: Boxes, t: t("why.pillar5.t"), d: t("why.pillar5.d") },
    { icon: Clock, t: t("why.pillar6.t"), d: t("why.pillar6.d") },
  ];
  return (
    <section data-testid="why-zopran" className="relative py-24 sm:py-28">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <div className="zp-label">{t("why.eyebrow")}</div>
            <h2 className="font-display text-3xl sm:text-5xl tracking-tighter mt-3 leading-[1.05]">
              {t("why.title.a")}{" "}
              <span className="text-[color:var(--zp-text-3)]">{t("why.title.b")}</span>
            </h2>
            <p className="text-[color:var(--zp-text-2)] mt-6 leading-relaxed max-w-md">
              {t("why.subtitle")}
            </p>

            <div className="mt-10 zp-card overflow-hidden p-0">
              <div className="grid grid-cols-3 px-5 py-3 text-xs uppercase tracking-[0.18em] text-[color:var(--zp-text-3)] border-b border-[color:var(--zp-border)] bg-[color:var(--zp-bg)]">
                <div className="col-span-1">{t("why.capability")}</div>
                <div className="text-center font-bold text-[color:var(--zp-cyan-3)]">{t("why.zopran")}</div>
                <div className="text-center">{t("why.generic")}</div>
              </div>
              {COMPARE.map(([k, a, b]) => (
                <div
                  key={k}
                  data-testid={`compare-row-${k.toLowerCase().replace(/\W+/g, "-")}`}
                  className="grid grid-cols-3 px-5 py-3.5 text-sm border-b border-[color:var(--zp-border)] last:border-b-0"
                >
                  <div className="text-[color:var(--zp-navy)] col-span-1">{k}</div>
                  <div className="text-center">
                    {a ? (
                      <Check size={16} className="inline text-emerald-500" />
                    ) : (
                      <X size={16} className="inline text-[color:var(--zp-text-3)]" />
                    )}
                  </div>
                  <div className="text-center">
                    {b ? (
                      <Check size={16} className="inline text-[color:var(--zp-text-3)]" />
                    ) : (
                      <X size={16} className="inline text-[color:var(--zp-text-3)]" />
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {PILLARS.map((p, i) => (
                <div key={i} data-testid={`why-pillar-${i}`} className="zp-card p-6">
                  <div className="w-10 h-10 rounded-lg bg-[color:var(--zp-bg-2)] grid place-items-center text-[color:var(--zp-cyan-3)]">
                    <p.icon size={18} strokeWidth={1.7} />
                  </div>
                  <h3 className="font-display text-lg mt-4 tracking-tight">{p.t}</h3>
                  <p className="text-[color:var(--zp-text-2)] text-sm mt-2 leading-relaxed">{p.d}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
